<template>
  <agencia-objetivo-import />
</template>

<script>
import AgenciaObjetivoImport from "@/modules/cobrox/components/AgenciaObjetivoImport/AgenciaObjetivoImport";

export default {
  name: "AgenciaObjetivoImportPage",
  components: {AgenciaObjetivoImport}
}
</script>
